/* 🤖 this file was generated by svg-to-ts */
export const iconDefiwallet: {
  name: 'defiwallet';
  data: string;
} = {
  name: 'defiwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#fff" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#123068" d="m19.15 24.75-2.12-1.94v-1l2.2-2.09V16.4l2.87-1.87L25.37 17l-4.44 7.75zm-5.57-5.24.32-3.12-1.07-2.79h6.34l-1.05 2.79.3 3.12zm1.45 3.29-2.12 1.97h-1.8l-4.47-7.78 3.29-2.44 2.89 1.84v3.32l2.2 2.09v1zM11.08 7.84h9.81l1.17 4.99H9.93zM16 1.64 3.55 8.82v14.36L16 30.36l12.45-7.18V8.82z"/></svg>`,
};
